var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6569 10.8431C12.7855 9.97181 11.7484 9.32678 10.6168 8.93631C11.8288 8.10159 12.625 6.70463 12.625 5.125C12.625 2.57478 10.5502 0.5 8 0.5C5.44978 0.5 3.375 2.57478 3.375 5.125C3.375 6.70463 4.17122 8.10159 5.38319 8.93631C4.25163 9.32678 3.2145 9.97181 2.34316 10.8431C0.832156 12.3542 0 14.3631 0 16.5H1.25C1.25 12.778 4.27803 9.75 8 9.75C11.722 9.75 14.75 12.778 14.75 16.5H16C16 14.3631 15.1678 12.3542 13.6569 10.8431ZM8 8.5C6.13903 8.5 4.625 6.986 4.625 5.125C4.625 3.264 6.13903 1.75 8 1.75C9.86097 1.75 11.375 3.264 11.375 5.125C11.375 6.986 9.86097 8.5 8 8.5Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/CustomerIcon.c48188fb7727f7ba8b16b1ff6c4069db.svg";
export { ForwardRef as ReactComponent };